import React, { useState } from 'react';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import { Block, BlockHead, BlockHeadContent, BlockTitle, Row } from '../../../../components/Component';
import CardTabs from '../../../components/cards/CardTabs';
import StockAgeAnalysisReportsSummary from './StockAgeAnalysisReportsSummary';
import FeatureUnderDevelopment from '../../../loaders/FeatureUnderDevelopment';
import StockAgeAnalysisReportBrandAnalysis from './StockAgeAnalysisReportBrandAnalysis';

const StockAgeAnalysisManagementDashboardHub = ({ tenant_info, user_info }) => {

  const [activeCardTab, setActiveCardTab] = useState("Summary");

  // Card Tabs
  const tabs = [
    { tabName: "Summary" },
    { tabName: "Brands Analysis" }
  ];

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Stock Age Analysis Report` : "Stock Age Analysis Report"} />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle page>Stock Age Analysis Reports</BlockTitle>
          </BlockHeadContent>
        </BlockHead>
        <Block>
          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} user_info={user_info} />
        </Block>

        <Block style={{ marginTop: '20px' }}>
          <Row className="g-gs" style={{ marginBottom: '20px' }}>
            {
              activeCardTab === "Summary" && (
                <>
                  <StockAgeAnalysisReportsSummary tenant_info={tenant_info} />
                </>
              )
            }
            {
              activeCardTab === "Brands Analysis" && (
                <>
                  <StockAgeAnalysisReportBrandAnalysis tenant_info={tenant_info} user_info={user_info} />
                </>
              )
            }
          </Row>
        </Block>

      </Content>
    </>
  );
};

export default StockAgeAnalysisManagementDashboardHub;